module.exports = __webpack_public_path__ + "img/bug.f61299f.svg";